/*
 * Copyright (c) 2026 Gabriele Bonora. Tutti i diritti riservati.
 *
 * Software proprietario. Nessuna licenza d'uso, copia, modifica o distribuzione
 * e' concessa in assenza di autorizzazione scritta del titolare dei diritti.
 * Vedere il file LICENSE nella radice del progetto.
 */
// Identita' del titolare del trattamento, costruita dall'anagrafica in Impostazioni.
// Nell'informativa privacy questi dati devono comparire per legge, quindi non possono
// restare scritti nel codice: cambiano con l'azienda che usa il gestionale.

export function sede(imp) {
  // "Corso Mazzini 34, 40062 Molinella (BO)" — la provincia sta attaccata al comune
  const citta = [
    [imp.azienda_cap, imp.azienda_comune].filter(Boolean).join(' '),
    imp.azienda_provincia ? `(${imp.azienda_provincia})` : null,
  ].filter(Boolean).join(' ');
  return [imp.azienda_indirizzo, citta].filter(Boolean).join(', ');
}

// "Denominazione, con sede in Via X, 40062 Molinella (BO), P.IVA 12345678901."
export function titolare(imp) {
  const nome = imp.azienda_denominazione || imp.app_nome;
  const parti = [nome];
  const s = sede(imp);
  if (s) parti.push(`con sede in ${s}`);
  if (imp.azienda_partita_iva) parti.push(`P.IVA ${imp.azienda_partita_iva}`);
  return parti.join(', ') + '.';
}

// Indirizzo a cui scrivere per i diritti GDPR
export function emailPrivacy(imp) {
  return imp.azienda_email || imp.azienda_pec || null;
}

// Attivita' svolta dall'azienda, per le finalita' del trattamento
export function attivita(imp) {
  return imp.azienda_attivita || 'assistenza tecnica';
}

// Anni di conservazione dei documenti fiscali
export function anniConservazione(imp) {
  const n = parseInt(imp.privacy_conservazione_anni, 10);
  return Number.isFinite(n) && n > 0 ? n : 10;
}

// L'informativa cita il Garante e la normativa italiana solo se l'azienda e' in Italia
export function inItalia(imp) {
  return (imp.azienda_nazione || 'IT').toUpperCase() === 'IT';
}

// "aggiornata al 25/08/2026", se la data e' stata impostata
export function aggiornataIl(imp) {
  const v = imp.privacy_aggiornata_il;
  if (!v) return null;
  const d = new Date(v);
  return isNaN(d.getTime()) ? null : d.toLocaleDateString('it-IT');
}
